<script>
    export let rating = 4.5;
    export let margin = '0';
    export let starSize = 12;
    export let wrapperSize = 16;

    import s from './style.module.css';
    import StarIcon from 'general/components/trustpilotStars/components/starIcon/StarIcon.svelte';
    let fullStars = 0;
    let halfStar = 0;
    let emptyStars = 0;

    $: {
        fullStars = Math.floor(rating);
        halfStar = rating % 1 >= 0.5 ? 1 : 0;
        emptyStars = 5 - fullStars - halfStar;
    }
</script>

<div class={s.stars} style="margin: {margin}" title="stars">
    {#each Array(fullStars) as _}
        <StarIcon {starSize} {wrapperSize} type="full" />
    {/each}

    {#if halfStar}
        <StarIcon {starSize} {wrapperSize} type="half" />
    {/if}

    {#each Array(emptyStars) as _}
        <StarIcon {starSize} {wrapperSize} type="empty" />
    {/each}
</div>
